/**
@description 客户端使用文件 初次服务器端加载，后面的路由会匹配到当前文件
*/

// document.domain = 'ztx1.chinatopcredit.com'

require('core-js/fn/promise')
require('core-js/fn/array')

import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'

import { browserHistory, Router, match } from 'react-router'
import axios from 'axios'
import { apiProxy } from 'settings'

import { createStore, preloadReducer } from 'shared/utils/redux'
//app level
import { reducer } from './modules/redux'
import { reducer as layoutReducer } from 'components/layout/redux';
import { routes } from './modules/routing'
import { expandData, transformBackstreet, successErrorMsg } from 'utils/httpTransform'

import './theme/main.scss'

const http = axios.create({
})

//if( !__DEVELOPMENT__ && !window.ie8 ) {
//  http.interceptors.request.use(function (config) {
//    for (let key in apiProxy) {
//      if (config.url.indexOf(key) >= 0 ) {//存在对应的配置path
//        config.url = apiProxy[key] + config.url
//        break
//      }
//    }
//    return config
//  })
//}
//
// /**
// @description 配置路由路径
// */
// http.interceptors.request.use(function (config) {
//   const url = config.url
//
//   if(isAbsoluteURL(url)) {
//     return config
//   }
//
//   for(let apiPrefix in apiProxy) {
//     if(url.startsWith(apiPrefix)) {//匹配路由api
//       config.url = combineURLs(apiProxy[apiPrefix], url)//合并前缀 使用对应环境的配置
//       return config
//     }
//   }
//   return config
// }, function (error) {
//   return Promise.reject(error)
// });

/**
@description  http拦截器
*/
http.interceptors.response.use(successErrorMsg)//请求拦截器
http.interceptors.response.use(transformBackstreet)//请求拦截器
http.interceptors.response.use(expandData)//请求拦截器
//AppContainer
class AppContainer extends Component {
  //组件加载后的生命周期
  componentDidMount() {
    const router = this.refs.router.router
    const { dispatch, getState } = this.props.store
    //added by 中腾信官网
    //显示返回顶部按钮
    $(window).scroll(function() {
      var scroolh = $(window).scrollTop()
      if (scroolh > 50) {
        $('.returnTop').addClass('returnTop_To')
      } else {
        $('.returnTop').removeClass('returnTop_To')
      }
    })
    //added by 中腾信 end

    //路由执行之前的回调
    router.listenBefore((location, cb) => {
      match({
        history: browserHistory,
        routes: router.routes,
        location
      }, (error, redirect, props) => {

        const { components, location, params } = props//组件 位置 参数

        dispatch({
          type: 'page.preload.start'
        })

        preload(components, {
          dispatch, getState,
          ...props
        }).then(() => {//完全预加载之后才会执行
          dispatch({ type: 'page.preload.finish' })
          cb()//执行具体的回调
        }).catch(error => {
          //preload出错
          console.error(error)
          dispatch({ type: 'page.preload.error', error })
        })
      })
    })
  }

  render() {
    return (
      <Provider store={this.props.store}>
        <Router onUpdate={() => window.scrollTo(0, 0)}  ref="router" history={browserHistory} routes={this.props.routes} />
      </Provider>
    )
  }
}

//自执行函数
void function render() {
  const reducers = {
    ...reducer,
    preload: preloadReducer,
    layout: layoutReducer
  }
  const store = createStore(http, reducers, window.__state)//提供应用的数据层
  ReactDOM.render(
    <AppContainer store={store} routes={routes} />,
    document.getElementById('root')
  )
}()

//预加载数据的函数
function preload(components, params) {//将所有的preload执行
  const preloads = components
  .filter(component => component.preload)
  .map(component => component.preload(params))
  return Promise.all(preloads)
}
export default http



// WEBPACK FOOTER //
// ./client.js